<template>
  <div id="tablePhone">
    <!-- barra de progreso -->
    <b-row class="col-8"
           style="border: 1px solid #ECEFF1; border-radius: 8px;">
      <!-- titulo -->
      <b-col cols="12" class="mt-4">
        <h4
            class="col-12 text-formatting-v2"
            style="font-size: 24px;">
          <strong>
            Progreso de perfiles actualizados
          </strong>
        </h4>
      </b-col>
      <!-- end -->
      <!-- barra de progreso -->
      <b-col cols="12" class="d-flex align-items-center mb-4">
        <div class="col-9">
          <b-progress
              :value="progressBarPhones.employees_with_photo"
              :max="progressBarPhones.total">
          </b-progress>
        </div>
        <div>
          <p class="col text-formatting-v2 ">
            <strong>
              {{progressBarPhones.percentage}}% cargado
            </strong>
          </p>
        </div>
      </b-col>
      <!-- end -->
    </b-row>
    <!-- end -->

    <template  v-if="loading3">
      <loader-version2 />
    </template>

    <template v-else>
      <b-row
          class="pt-5"
          style="margin-left: -30px;">

        <!-- boton de filtro -->
        <b-col cols="12"  class="mb-3">
          <button v-b-toggle.filtroPhotos class="button-v2 outline-primary border-round d-flex float-left">
            <div class="m-1 d-flex align-items-center">
              <p class="m-0 pr-2">Filtro</p>
              <img class="centerImg1 arrow" src="@/assets/images/icons/ht_icon_stack.svg" width="15px">
            </div>
          </button>
        </b-col>
        <!-- end -->

        <!-- filtro -->
        <b-col cols="12" class="mb-3">
          <b-collapse
              id="filtroPhotos"
              class="col-12 mt-4 py-5 filter card-v2 with-border">
            <b-container>
              <b-row>
                <b-col class="8">

                  <!-- busqueda -->
                  <b-col>
                    <h3 class="text-formatting-v2" style="font-weight: 700; font-size: 18px; line-height: 24px;">
                      <strong>Buscar</strong>
                    </h3>
                    <hr>
                  </b-col>
                  <b-col>
                    <div
                        class="left-and-right-inner-addon"
                        style="top: -10px;">
                      <input
                          v-model="filterPhone"
                          @keydown="startTipyngPhone()"
                          @keyup="finishTipyngPhone()"
                          type="text"
                          class="col-12 my-3 input-v2 input-v2-by-search with-image-left"
                          placeholder="Busqueda por nombre o ID">
                    </div>
                  </b-col>
                  <!-- end -->

                  <!-- quitar filtros -->
                  <b-col>
                    <button
                        class="button-v2 danger border-round mt-2 mb-4"
                        @click.prevent="filterPhone = '',  filterSelectedPhone = null, filterStatusPhone()">
                      <strong class="text-formatting-v2">
                        Quitar todos los filtros
                      </strong>
                    </button>
                  </b-col>
                  <!-- end -->
                </b-col>
                <b-col class="4">
                  <b-col>
                    <h3 class="text-formatting-v2" style="font-weight: 700; font-size: 18px; line-height: 24px;">
                      <strong>Estado</strong>
                    </h3>
                    <hr>
                  </b-col>
                  <!-- estados -->
                  <b-col class="ml-4 mt-4">
                    <input
                        v-model="filterSelectedPhone"
                        type="radio"
                        v-on:change="filterStatusPhone()"
                        id="approved"
                        name="approved"
                        value="approved"
                        class="mr-2">
                    <label for="approved">
                                        <span
                                            class="status mt-4 p-1 text-formatting-v2"
                                            style="background-color:#EDF9F0; color: #00761A; border-radius: 8px;">
                                            <img
                                                class="centerImg1 mr-2"
                                                src="@/assets/images/icons/check.svg"
                                                width="20px">Cargado
                                        </span>
                    </label>
                  </b-col>
                  <b-col class="ml-4 mt-2">
                    <input
                        v-model="filterSelectedPhone"
                        type="radio"
                        v-on:change="filterStatusPhone()"
                        id="pending"
                        name="pending"
                        value="pending"
                        class="mr-2 ">
                    <label for="pending">
                                        <span
                                            class="status mt-4 p-1 text-formatting-v2"
                                            style="background-color:#FFF4EC; color: #E66401; border-radius: 8px;">
                                            <img
                                                class="centerImg1 mr-2"
                                                src="@/assets/images/icons/orange-clock.svg"
                                                width="20px">Pendiente
                                        </span>
                    </label>
                  </b-col>
                  <b-col class="ml-4 mt-2">
                    <input
                        v-model="filterSelectedPhone"
                        type="radio"
                        v-on:change="filterStatusPhone()"
                        id="all"
                        name="all"
                        value=""
                        class="mr-2">
                    <span class="status mt-4 p-1 text-formatting-v2">
                                            Todos
                                        </span>
                  </b-col>
                  <!-- end -->
                </b-col>
              </b-row>
            </b-container>
          </b-collapse>
        </b-col>
        <!-- end -->

        <!-- tabla -->
        <b-col
            cols="12"
            class="table-responsive datatable no-box-shadow table-with-borders-and-box-shadow">
          <b-table
              id="b-table"
              :fields="fields"
              :items="dataTablePhone.rows"
              class="col-12 mt-2">
            <template #cell(edit)="row">
                        <span
                            style="font-size:10px;"
                            class="pointer ml-3 mr-3"
                            @click.prevent="editPhone(row.item.edit)">
                            <img
                                class="centerImg1 ml-3"
                                :src="require('@/assets/images/icons/ht_icon_edit_v2.svg')"
                                width="20px"/>
                        </span>
            </template>
            <template #cell(name)="row">
              <td class="pl-2">
                {{row.item.name.name}}<br>
                <b>
                  <img
                      class="centerImg1"
                      :src="require('@/assets/images/icons/ht_icon_user.svg')"
                      width="20px">
                  {{row.item.name.cc}}
                </b>
              </td>
            </template>
          </b-table>

          <!-- paginacion -->
          <b-col
              cols="12"
              class="pagination-v2 my-5 d-flex justify-content-center">
            <Pagination
                :data="tablePhone"
                :limit="10"
                @pagination-change-page="loadRowsPhonePag" />
          </b-col>
          <!-- end -->
        </b-col>
        <!-- end -->
      </b-row>

      <!-- modal de creacion|edicion -->
      <modal-confirmation
          v-if="userEditOrCreate.id"
          modal-id="modal-create-edit-phone"
          include-loader
          :processing="processing"
          :disable-accepted-button="validPhone"
          include-button-cancel
          @click:accepted="savePhone">
        <template #body>
          <!-- titulo & nomvre del usuario que se edita -->
          <p class="text-formatting-v2 h2-v2 text-center">
            <strong>
              Ingresar teléfono de <br>
              {{ mapperText(userEditOrCreate.name) }}
            </strong>
          </p>
          <!-- end -->

          <!-- telefono actual & se muestra si tiene un telefono -->
          <p
              v-if="userEditOrCreate.phone"
              class="text-formatting-v2 text-center pt-2" >
            Su teléfono actual es: {{ userEditOrCreate.phone }}
          </p>
          <!-- end -->

          <!-- numero de telefono -->
          <input
              type="number"
              v-model.trim="userEditOrCreate.newPhone"
              class="p-2 mt-3 input-v2 text-center"
              placeholder="Ingresa número">
          <!-- end -->
        </template>
        <template #buttonText>
          <strong>
            Confirmar
          </strong>
        </template>
      </modal-confirmation>
      <!-- end -->

      <!-- modal para todo ok -->
      <modal-confirmation
          modal-id="modal-success"
          v-if="message.message"
          @click:accepted="$bvModal.hide('modal-success')">
        <template #body>
          <img
              class="col-4 my-3"
              src="@/assets/images/icons/ht_icon_checkbox_circle_line.svg" />
          <p class="text-formatting-v2 h2-v2 text-center">
            <strong>
              ¡Proceso exitoso!
            </strong>
          </p>
          <p class="text-formatting-v2 text-center">
            {{ message.message }}
          </p>
        </template>
        <template #buttonText>
          <strong>
            Entendido
          </strong>
        </template>
      </modal-confirmation>
      <!-- end -->


      <!-- modal error -->
      <modal-confirmation
          v-if="error.message"
          modal-id="modal-fail"
          @click:accepted="$bvModal.hide('modal-fail')">
        <template #body>
          <img
              class="col-4 my-3"
              src="@/assets/images/icons/ht_icon_close_circle_line.svg" />
          <p class="text-formatting-v2 h2-v2 text-center">
            <strong>
              ¡Proceso fallido!
            </strong>
          </p>
          <p class="text-formatting-v2 text-center">
            {{ error.message }}
          </p>
        </template>
        <template #buttonText>
          <strong>
            Entendido
          </strong>
        </template>
      </modal-confirmation>
      <!-- end -->
    </template>
  </div>
</template>

<script>
import { mapState,mapActions } from "vuex";
import Pagination from "laravel-vue-pagination";
export default {
  components: {
    Pagination,
    ModalConfirmation: () => import('@/components/common/modal/ModalConfirmation.vue')
  },
  data() {
    return {
      dataTablePhone:{
        rows: [],
      },
      runtimePhone:'',
      filterPhone:'',
      filterSelectedPhone:[],
      newPhone:'',
      userEditOrCreate: {
        id: null,
        name: null,
        phone: null,
        newPhone: ''
      },
      processing: false
    }
  },
  computed: {
    ...mapState("modOhAnalyst", [
      "loading3",
      "tablePhone",
      "employeeInfoPhone",
      "error",
      "message",
      "progressBarPhones"
    ]),
    fields () {
      return [
        {
          label: 'Nombre / C.C',
          key: 'name',
          sortable: true
        },
        {
          label: 'Cargo',
          key: 'position',
          sortable: true
        },
        {
          label: 'Área',
          key: 'area',
          sortable: true
        },
        {
          label: 'Telefonó',
          key: 'phone',
          sortable: true
        },
        {
          label: 'Editar',
          key: 'edit',
          sortable: false
        },
      ]
    },
    validPhone () {
      return this.userEditOrCreate.newPhone.length !== 10 || this.userEditOrCreate.newPhone === this.userEditOrCreate.phone
    }
  },
  beforeMount(){
    let data = {
      page:1
    }
    this.loadRowsPhone(data)
    this.actGetProgressBarPhones()
  },
  methods: {
    ...mapActions("modOhAnalyst", [
      'actCheckEmployeesWithPhone',
      'actGetEmployeePhone',
      'actSaveEmployeePhone',
      'actGetProgressBarPhones'
    ]),
    startTipyngPhone(){
      clearTimeout(this.runTime)
    },
    editPhone({ id, name, phone }){
      this.userEditOrCreate.id = id
      this.userEditOrCreate.name = name
      this.userEditOrCreate.phone = phone
      this.userEditOrCreate.newPhone = ''
      this.$root.$emit('bv::show::modal','modal-create-edit-phone')
    },
    async savePhone(){
      if (this.validPhone) { return }
      this.processing = true
      await this.actSaveEmployeePhone({
        phone:this.userEditOrCreate.newPhone,
        id:this.userEditOrCreate.id
      }).then(() => {
        if(this.error.message){
          this.$root.$emit('bv::hide::modal','modal-confirm')
          this.$root.$emit('bv::show::modal','modal-fail')

        }else{
          this.$root.$emit('bv::hide::modal','modal-confirm')
          this.$root.$emit('bv::show::modal','modal-success')
          this.loadRowsPhone({ page: 1})
          this.actGetProgressBarPhones()
        }
      })
      this.processing = false
    },
    finishTipyngPhone(){
      let data = {
        search: this.filterPhone,
        status: this.filterSelectedPhone
      }
      this.runTimePhone = setTimeout(() => {
        this.loadRowsPhone(data)
      }, 1500);
    },
    filterStatusPhone(){
      let data = {
        search: this.filterPhone,
        status: this.filterSelectedPhone
      }
      this.loadRowsPhone(data)
    },
    async loadRowsPhone(data){
      await this.actCheckEmployeesWithPhone(data).then(() =>{
        this.dataTablePhone.rows = []

        this.tablePhone.data.forEach(x => {

          this.dataTablePhone.rows.push({
            name: {
              name:x.name,
              cc: x.cc
            },
            position: x.charge,
            area: x.area,
            phone: (x.phone ? x.phone:'---'),
            edit: x
          })
        })
      })
      this.forgetTableStyleById()
    },
    loadRowsPhonePag(page = 1){
      let data = {
        search: this.filter,
        page:page,
        status: this.filterSelected
      }
      this.loadRowsPhone(data)
    },
  }
}
</script>

<style lang="scss">
#tablePhone {
  .progress-bar {
    background: linear-gradient(270deg, #0C9E42 -0.16%, #7DFFA9 100%);
  }
  .filter{
    border: solid rgb(207, 207, 207) 1px;
    border-radius: 10px;
    background-repeat: no-repeat;
    background-position: right bottom;
    background-size: 15%;
    h3{
      font-weight: 600;
      color:#1C6776;
    }
  }
  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #1C3A4E;
    padding-left: 5%;
    text-align: justify;
  }

  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 150px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s
  }

  @-webkit-keyframes animatebottom {
    from { bottom:-100px; opacity:0 }
    to { bottom:0px; opacity:1 }
  }

  @keyframes animatebottom {
    from{ bottom:-100px; opacity:0 }
    to{ bottom:0; opacity:1 }
  }

  #myDiv {
    display: none;
    text-align: center;
  }
  font-family: Open Sans;
  .responsible{
    background-color: #EEF2FA;
  }
  h4{
    font-weight: 600;
    font-size: 16px;
  }
  .alert{
    color:black;
  }
  .icon{
    font-size: 20px;
  }
  .regular{
    padding: 5px 15px;
    font-size: 16px;
    border-radius: 100px;
    background-color: white;
    border: 2px solid #269887;
    color: #269887;
  }
  .btn-create{
    padding: 12px;
    border-radius: 20px;
    background-color: #269887;
    border: none;
    color: white;
    display: flex;
    align-items: center;
    transition: 0.5s;

    span {
      font-size: 30px;
      line-height: 0;
      margin: 0 5px;
      font-weight: 500;
    }
  }
  .btn-create:hover{
    background-color: #27a391;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
  }
  .check-status{
    .status{
      padding: 5px 10px;
      border-radius: 20px;
      font-size: 14px;
    }
  }
  .file-upload-img {
    height: 200px;
    border-radius: 15px;
    text-align: center;
    display: flex;
    align-items: center;
    border: 2px #0C9E42 dashed;
    margin-bottom: 15px;
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);

    input[type="file"] {
      opacity: 0;
      filter: alpha(opacity=0);
      display: block;
      position: absolute;
      cursor: pointer;
      z-index: 1;
      height: 150px;
    }

    span p{
      height: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>